import React from 'react'
import RadioGroup from '../shared/radio-group'

const ThemeSwitch = ({ theme, onChange, className }) => (
  <RadioGroup
    items={[
      { value: 'light', label: 'Light theme' },
      { value: 'dark', label: 'Dark theme' },
    ]}
    selected={theme}
    onChange={onChange}
    className={className}
  />
)

export default ThemeSwitch
